angular.module('shiftTraderApp.constants', [])
    .value('regexStrings', { //jshint ignore:line
      email: "[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-z0-9](?:[A-z0-9-]*[a-z0-9])?\\.)+[A-z0-9](?:[A-z0-9-]*[A-z0-9])?", // jshint ignore:line
      phone: "^([0-9]( |-)?)?(\\(?[0-9]{3}\\)?|[0-9]{3})( |-)?([0-9]{3}( |-)?[0-9]{4})$", // jshint ignore:line
      money: "^([1-9]{1}[0-9]{0,2}(\,[0-9]{3})*(\.[0-9]{0,2})?|[1-9]{1}[0-9]{0,}(\.[0-9]{0,2})?|0(\.[0-9]{0,2})?|(\.[0-9]{1,2})?)$", // jshint ignore:line
      positiveInt: "^[1-9][0-9]*$" // This regex will only accept positive integer (0 is not accepted) //jshint ignore:line
    }) // jshint ignore:line
    .value('saViewShiftRowHeightInt', 20)
    .value('saViewShiftHourWidthInt', 40)
    .value('saMiniDayViewShiftHeightInt', 11)
    .value('saIntelliViewShiftPublishedWidthInPx', 20)
    .value('saIntelliViewShiftDropdownWidthInPx', 8 + 4 + 2) //$intelliViewShiftDropdownArrowWidth + $intelliViewShiftDropdownArrowRightMargin + fudge factor
    .value('zIndexManageWorkPeriodsMax', 8000)
    .value('zIndexManageWorkPeriodsDeptInterval', 1000)
    .value('zIndexManageWorkPeriodsPosInterval', 50)
    .value('saDrawShiftBarHeight', 20)
    .value('saNoteGlobalButtonHeightOffset', 80)
    .value('saNoteDefaultVisibleReplies', 1)
    .value('saNoteReplyAbbreviationThreshold', 3)  // Max number of note replies to display by default before collapsing them down
    .value('saNotePermissionLevels', {
          0: {
            label: 'Public',
            description: 'Everyone will be able to view this note.',
            iconClass: 'icon-globe',
            id: 0
          },
          1: {
            label: 'Management',
            description: 'Only management and admins will be able to view this note.',
            iconClass: 'icon-user-md',
            id: 1
          },
          2: {
            label: 'Admins',
            description: 'Only admins will be able to view this note.',
            iconClass: 'icon-star',
            id: 2
          }
        })
    .value('saNoteMessageParseDelay', 250)
    .value('saMediaExpirationSeconds', 30)
    .value('saMediaLinkMatchers', {
      youtube: {
        check:  /^(https?\:\/\/)?(www\.)?youtu(\.be\/|be\.com\/)*/gi,
        capture: /^.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/i
      },
      vimeo: {
        capture: /^(?:https?\:\/\/)?(?:(?:www\.)?vimeo\.com\/|player\.vimeo\.com\/video\/)(\d+)*/i
      }
    })
    .value('saNoteShowContextMenu', true)
    .value('EventStreamNames', {
      mwpUpdates: 'sa:manageWorkPeriods:updates',
      mwpCollapseChange: 'sa:manageWorkPeriods:collapseChangeUpdates',
      barIntervalUpdates: 'sa:manageWorkPeriods:barIntervalUpdates',
      notesOverlayContext: 'sa:notesOverlayContext'
      })
    .value('saShiftTemplateAPILimit', 40)
    .value('saDemoPlanId', 'SA-PLUS-DEMO')
    .value('validCouponCodes', ['ATLNEWYEAR', 'CFASPECIAL', 'WORKCLIMATE', 'EXTRAMONTH4CFA', 'EXTRAMONTH4BO'])
    .value('saUserPayRatesEditorSelectionEventName', 'sa:saUserPayRatesEditor:selectRow')
    .value('saUserPayRatesEditorRowChangeEventName', 'sa:saUserPayRatesEditor:rowChange')
    .value('saUserPayRatesEditorAddException', 'sa:saUserPayRatesEditor:addException')
    .value('saUserPayRatesEditorRemoveException', 'sa:saUserPayRatesEditor:removeException')
    .value('saUserPayRatesEditorRefresh', 'sa:saUserPayRatesEditor:refresh')
    .value('saUserPayRatesManagerDeleteAll', 'sa:saUserPayRatesManager:deleteAll')
    .value('saUserPayRatesManagerRefresh', 'sa:saUserPayRatesManager:refresh')
    .value('saUserPayRatesManagerFilter', 'sa:saUserPayRatesManager:filter')
    .value('TYPE_CFA_PERSON_ID', 'cfa_person_id')
    .value('TYPE_CFA_EMPLOYEE_NUMBER', 'cfa_employee_number')
    .value('CFA_LOCATION_IDENTIFIER_TYPE', 'cfa_location_number')
    .value('CFA_INTEGRATION_TYPE', 'ExternalIntegration::CfaIntegration')
